import { render, staticRenderFns } from "./aproveFlow.vue?vue&type=template&id=4966a328&scoped=true&"
import script from "./aproveFlow.vue?vue&type=script&lang=js&"
export * from "./aproveFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4966a328",
  null
  
)

export default component.exports